var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component rotate-device"},[_c('img',{attrs:{"src":"/assets/svg/rotate.svg","alt":"Rotate device icon"}})])}]

export { render, staticRenderFns }